import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

const KEY_STORAGE = "phs_admin_key";

export function getAdminKey() {
  return sessionStorage.getItem(KEY_STORAGE) || "";
}

export function setAdminKey(key) {
  if (key) sessionStorage.setItem(KEY_STORAGE, key);
  else sessionStorage.removeItem(KEY_STORAGE);
}

export const adminApi = axios.create({
  baseURL: ADMIN_API,
});

adminApi.interceptors.request.use((config) => {
  const key = getAdminKey();
  if (key) config.headers["x-admin-key"] = key;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 403) {
      setAdminKey("");
      if (!window.location.pathname.endsWith("/adminpanel/login")) {
        // Preserve the current admin URL (including query) for post-login redirect.
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/adminpanel/login?next=${next}`;
      }
    }
    return Promise.reject(err);
  }
);

export async function adminLogin(emailOrKey, password) {
  // Backward-compat: when called as adminLogin(key) treat the single arg as
  // the legacy admin_key. When called as adminLogin(email, password), post
  // both fields and remember the password as the x-admin-key header value.
  if (password === undefined) {
    const res = await axios.post(`${BACKEND_URL}/api/admin/login`, { admin_key: emailOrKey });
    if (res.data?.ok) {
      setAdminKey(emailOrKey);
      return true;
    }
    return false;
  }
  const res = await axios.post(`${BACKEND_URL}/api/admin/login`, { email: emailOrKey, password });
  if (res.data?.ok) {
    setAdminKey(password);
    return true;
  }
  return false;
}
